
export class EdlRegistrationToken {
  PortalID: string;
  ApplicationContext: number;
  Token: string;
  Description: string;
}